export default __webpack_public_path__ + "static/media/photo--sm--18.09945408.jpg";